import { axios } from '@/services/axios';

const savePermission = async ({ data }) => {
    const res = await axios.put('/permission/', data);
    return res.data;
};

export default savePermission;
